import { Star } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'

const testimonials = [
  {
    name: 'Sarah Johnson',
    role: 'Operations Manager',
    company: 'FreightForward Inc.',
    content: 'AIBoard has revolutionized how we manage our freight operations. The unified API integration saves us hours every day.',
    rating: 5,
  },
  {
    name: 'Michael Chen',
    role: 'Logistics Director',
    company: 'Global Shipping Solutions',
    content: 'The real-time updates and filtering capabilities are game-changers. We can now respond to market changes instantly.',
    rating: 5,
  },
  {
    name: 'Emily Rodriguez',
    role: 'Supply Chain Manager',
    company: 'Metro Transport LLC',
    content: 'The security features and reliability of AIBoard give us complete confidence in our freight data management.',
    rating: 5,
  },
]

export default function TestimonialsSection() {
  return (
    <section className="w-full py-16 md:py-24 lg:py-32 bg-gradient-to-br from-white to-accent-50/30">
      <div className="container px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-8 text-center">
          <div className="space-y-6">
            <div className="inline-flex items-center rounded-full border px-6 py-3 text-sm bg-gradient-to-r from-accent-50 to-primary-50 border-accent-200 text-accent-700">
              <Star className="mr-2 h-4 w-4" />
              Customer Stories
            </div>
            <h2 className="text-4xl font-bold tracking-tighter sm:text-5xl md:text-6xl bg-gradient-to-r from-accent-600 via-accent-700 to-primary-600 bg-clip-text text-transparent">
              What Our Customers Say
            </h2>
            <p className="max-w-[800px] text-neutral-600 text-lg md:text-xl leading-relaxed">
              Trusted by logistics professionals worldwide to streamline their operations.
            </p>
          </div>
        </div>
        <div className="mx-auto grid max-w-6xl items-start gap-8 py-12 lg:grid-cols-3 lg:gap-12">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="relative bg-gradient-to-br from-white via-white to-accent-50/20 border-accent-200 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 overflow-hidden group">
              <div className="absolute inset-0 bg-gradient-to-br from-accent-500/5 to-primary-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <CardContent className="pt-8 relative">
                <div className="flex items-center space-x-1 mb-6">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-warning-400 text-warning-400 drop-shadow-sm" />
                  ))}
                </div>
                <blockquote className="text-lg mb-6 leading-relaxed text-neutral-700 relative">
                  <div className="absolute -top-2 -left-2 text-6xl text-accent-200 opacity-50">"</div>
                  {testimonial.content}
                  <div className="absolute -bottom-4 -right-2 text-6xl text-accent-200 opacity-50">"</div>
                </blockquote>
                <div className="flex items-center space-x-4 pt-4 border-t border-accent-100">
                  <div className="flex-shrink-0">
                    <div className="h-12 w-12 rounded-full bg-gradient-to-br from-accent-100 to-accent-200 flex items-center justify-center border-2 border-accent-300 shadow-md">
                      <span className="text-sm font-bold text-accent-700">
                        {testimonial.name.split(' ').map(n => n[0]).join('')}
                      </span>
                    </div>
                  </div>
                  <div>
                    <p className="font-semibold text-neutral-800">{testimonial.name}</p>
                    <p className="text-sm text-neutral-600">
                      {testimonial.role}
                    </p>
                    <p className="text-sm text-accent-600 font-medium">
                      {testimonial.company}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
} 